import React from 'react'
import { FeatureFlagColor } from './FeatureFlagColor.type'

export type FeatureFlagProps = {
  backgroundColor?: FeatureFlagColor
  textColor?: string
  label?: string
  testId?: string
}

export const FeatureFlag = (props: FeatureFlagProps) => {
  const { backgroundColor, label, testId } = props

  const getBackgroundColor = () => {
    if (backgroundColor === 'berry') {
      return 'Chip--ribbon'
    }
    return 'Chip--ribbon-lime'
  }
  return (
    <div className={`${getBackgroundColor()} Card--featureFlag `} data-testid={testId ?? null}>
      {label}
    </div>
  )
}

export default FeatureFlag
